import Axios from 'axios';
import { setupCache, buildWebStorage } from 'axios-cache-interceptor';

const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const axios = Axios.defaults.cache ? Axios : setupCache(Axios, {
    storage: buildWebStorage(localStorage, 'axios-cache:'),
    methods: ['get', 'post']
});

axios.defaults.headers['X-Time-Zone'] = userTimeZone;

// Need to add custom Date format to exclude conversion to the local browser timezone
// when browser creates new date object like "new Date()", it corrects for Daytime Saving Time.
// when browser create new date object like "new Date(1,1,1,1,1,)" it does not correct for DST.
// when user creates dates, it is assumed they mean local time. Local browser time zone
// is sent in the header of the Axios Request as X-Time-Zone.  On server, we convert any user entered
// DateTime to DST adjusted UTC time using the raw date info created by toCustomISOString
// and the TimeZone header.

// Define the toCustomISOString function for Date objects.
Date.prototype.toCustomISOString = function () {
    const year = this.getFullYear();
    const month = String(this.getMonth() + 1).padStart(2, '0');
    const day = String(this.getDate()).padStart(2, '0');
    const hours = String(this.getHours()).padStart(2, '0');
    const minutes = String(this.getMinutes()).padStart(2, '0');
    const seconds = String(this.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status >= 300 && error.response.status < 400) {
        // Redirect the user to the location specified in the redirect response
        location.href = error.response.headers.location;
    } 
    else if (401 === error.response.status || 403 == error.response.status) {
        location.href = "/Account/Login";
    }
    else {
        return Promise.reject(error);
    }
});

// Add an interceptor to modify request data
axios.interceptors.request.use((config) => {
    // Recursively search for Date objects in the request data and apply toCustomISOString
    const transformDates = (data) => {
        for (const key in data) {
            if (data[key] instanceof Date) {                
                data[key] = data[key].toCustomISOString();
            } else if (typeof data[key] === 'object') {
                transformDates(data[key]);
            }
        }
    }

    if (config.data) {
        transformDates(config.data);
    }

    return config;
});

export default axios;